import { useApi } from '@/api'

export const usePlatformInvitationsResource = () => {
  const invitations = useApi().api.v1.admin['platform-invitations']

  return {
    getPlatformInvitations: () => invitations.get(),
    setPlatformInvitation: (email: string) => invitations.post({ email }),
    setPlatformInvitationRevoke: (id: string) => invitations({ id }).revoke.post()
  }
}
